export default __webpack_public_path__ + "static/media/NightCloud.1396d8b1.mp4";